<template>

<svg xmlns="http://www.w3.org/2000/svg"  viewBox="-11.5 780.5 24 24" >
<path d="M1.2,795.65v-0.24h0.6l0.39-1.11h-3.31l0.39,1.11h0.6v0.24c0,1.98-0.85,3.88-2.34,5.19l3.01,1.65l3.01-1.65
	C2.05,799.53,1.2,797.64,1.2,795.65z"/>
<path d="M-5.25,799.95v0.49h2.49c0.17-0.15,0.33-0.32,0.48-0.49H-5.25z"/>
<path d="M3.82,800.44h2.44v-0.49H3.34C3.49,800.12,3.65,800.29,3.82,800.44z"/>
<path d="M2.53,798.82H7.4v-0.49H2.29C2.36,798.51,2.45,798.67,2.53,798.82z"/>
<path d="M-1.22,798.34H-6.4v0.49h4.92C-1.39,798.67-1.3,798.51-1.22,798.34z"/>
<path d="M1.88,797.21h6.65v-0.49H1.78C1.8,796.89,1.84,797.05,1.88,797.21z"/>
<path d="M-0.72,796.72h-6.81v0.49h6.71C-0.78,797.05-0.75,796.89-0.72,796.72z"/>
<polygon points="-1.36,795.1 -8.27,795.1 -8.27,795.59 -1.19,795.59 "/>
<polygon points="2.25,795.59 9.27,795.59 9.27,795.1 2.42,795.1 "/>
<path d="M-1.59,793.81h4.24c3.69,0,4.55-2.71,4.74-3.59H-6.33C-6.15,791.11-5.27,793.81-1.59,793.81z"/>
<path d="M-0.78,789.72h0.53l-0.1-0.24l0.25-0.6l0.64-0.25l0.64,0.25l0.25,0.6l-0.1,0.24H7.4v-0.24c0.06-3.79-2.97-6.92-6.76-6.98
	c-3.79-0.06-6.92,2.97-6.98,6.76c0,0.07,0,0.14,0,0.21v0.24H-0.78z M6.91,789.23H4.28l2.24-1.95
	C6.75,787.91,6.88,788.56,6.91,789.23L6.91,789.23z M6.26,786.65l-2.81,0.28l1.77-1.78C5.63,785.6,5.98,786.11,6.26,786.65
	L6.26,786.65z M3.31,783.73c0.58,0.28,1.1,0.64,1.57,1.08l-1.79,1.79L3.31,783.73z M5.89,787.17l-2.35,2.06h-1.7l-0.2-0.49
	l1.26-1.26L5.89,787.17z M0.77,783.1c0.65,0.02,1.28,0.15,1.89,0.36l-1.89,2.04V783.1z M0.77,786.22l2.02-2.17l-0.24,3.09
	l-1.26,1.27l-0.52-0.21V786.22z M0.29,783.1v2.41l-1.9-2.05C-1,783.24-0.36,783.12,0.29,783.1z M0.29,786.22v1.97l-0.52,0.21
	l-1.26-1.26l-0.24-3.09L0.29,786.22z M-2.25,783.74l0.22,2.87l-1.79-1.79C-3.35,784.38-2.82,784.02-2.25,783.74z M-4.16,785.16
	l1.78,1.77l-2.8-0.28C-4.92,786.11-4.58,785.61-4.16,785.16z M-5.84,789.23c0.03-0.67,0.16-1.33,0.39-1.95l2.24,1.95H-5.84z
	 M-4.83,787.18l2.98,0.31l1.26,1.26l-0.2,0.49h-1.7L-4.83,787.18z"/>
<path d="M-4.66,793.49h-3.61v0.49h4.62C-4.01,793.85-4.35,793.69-4.66,793.49z"/>
<path d="M4.72,793.98h4.55v-0.49H5.73C5.41,793.69,5.07,793.85,4.72,793.98z"/>
<path d="M6.93,792.37h2.34v-0.49H7.25C7.15,792.05,7.05,792.21,6.93,792.37z"/>
<path d="M-6.19,791.88h-2.08v0.49h2.4C-5.99,792.21-6.1,792.05-6.19,791.88z"/>
<path d="M-6.82,790.25h-1.45v0.49h1.58C-6.76,790.55-6.8,790.38-6.82,790.25z"/>
<path d="M7.88,790.25c-0.03,0.13-0.07,0.29-0.13,0.49h1.52v-0.49H7.88z"/>
</svg>

</template>